// extracted by mini-css-extract-plugin
export default {"container":"_34km","link":"_1ych"};